import { render, staticRenderFns } from "./TagDeleteForm.vue?vue&type=template&id=11917b48&"
import script from "./TagDeleteForm.vue?vue&type=script&lang=ts&"
export * from "./TagDeleteForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports